// AgingTable.js
import React from 'react';
import { Card } from 'react-bootstrap';

const AgingTable = ({ title, data }) => {
    const formatCurrency = (value) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(value);
    };

    return (
        <Card className="mb-4">
            <Card.Header className="bg-light">
                <h6 className="mb-0">{title}</h6>
            </Card.Header>
            <Card.Body className="p-0">
                <div className="table-responsive">
                    <table className="table table-bordered table-sm mb-0">
                        <thead>
                        <tr>
                            <th>0-30</th>
                            <th>31-60</th>
                            <th>61-90</th>
                            <th>91+</th>
                            <th>Total</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{formatCurrency(data.days0to30)}</td>
                            <td>{formatCurrency(data.days31to60)}</td>
                            <td>{formatCurrency(data.days61to90)}</td>
                            <td>{formatCurrency(data.daysOver90)}</td>
                            <td>{formatCurrency(data.total)}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </Card.Body>
        </Card>
    );
};

export default AgingTable;